var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgAiSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.414 9.38449C12.4151 9.56437 12.3604 9.74018 12.2575 9.88772C12.1546 10.0353 12.0085 10.1473 11.8393 10.2084L8.99485 11.2595L7.94705 14.1062C7.885 14.2748 7.77274 14.4202 7.62541 14.523C7.47808 14.6258 7.30278 14.6809 7.12315 14.6809C6.94353 14.6809 6.76823 14.6258 6.6209 14.523C6.47357 14.4202 6.36131 14.2748 6.29926 14.1062L5.24485 11.2595L2.39815 10.2117C2.22959 10.1497 2.08411 10.0374 1.98135 9.89006C1.87858 9.74273 1.82349 9.56743 1.82349 9.3878C1.82349 9.20818 1.87858 9.03287 1.98135 8.88554C2.08411 8.73822 2.22959 8.62595 2.39815 8.56391L5.24485 7.50949L6.29264 4.6628C6.35469 4.49423 6.46695 4.34876 6.61428 4.24599C6.76161 4.14323 6.93691 4.08813 7.11654 4.08813C7.29616 4.08813 7.47147 4.14323 7.61879 4.24599C7.76612 4.34876 7.87839 4.49423 7.94043 4.6628L8.99485 7.50949L11.8415 8.55729C12.0108 8.61894 12.1569 8.73163 12.2594 8.8798C12.3619 9.02797 12.4159 9.20432 12.414 9.38449Z",
    fill: "url(#paint0_linear_2740_66869)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0587 4.08822C15.0593 4.17812 15.032 4.26599 14.9805 4.33973C14.9291 4.41347 14.8561 4.46946 14.7715 4.5L13.3496 5.02532L12.8258 6.44807C12.7948 6.53232 12.7386 6.60503 12.665 6.65638C12.5913 6.70774 12.5037 6.73528 12.4139 6.73528C12.3241 6.73528 12.2365 6.70774 12.1628 6.65638C12.0892 6.60503 12.0331 6.53232 12.002 6.44807L11.475 5.02532L10.0519 4.50165C9.96765 4.47064 9.89493 4.41453 9.84356 4.3409C9.79219 4.26726 9.76465 4.17965 9.76465 4.08987C9.76465 4.0001 9.79219 3.91249 9.84356 3.83885C9.89493 3.76522 9.96765 3.70911 10.0519 3.6781L11.475 3.15112L11.9987 1.72837C12.0298 1.64413 12.0859 1.57142 12.1595 1.52006C12.2332 1.4687 12.3208 1.44116 12.4106 1.44116C12.5004 1.44116 12.588 1.4687 12.6617 1.52006C12.7353 1.57142 12.7914 1.64413 12.8225 1.72837L13.3496 3.15112L14.7726 3.67479C14.8572 3.70561 14.9302 3.76193 14.9815 3.83598C15.0327 3.91003 15.0597 3.99817 15.0587 4.08822Z",
    fill: "url(#paint1_linear_2740_66869)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2740_66869",
    x1: 6.91387,
    y1: -7.16663,
    x2: 20.8213,
    y2: 0.784599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E56B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8178EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2740_66869",
    x1: 12.3093,
    y1: -4.18384,
    x2: 19.2608,
    y2: -0.208669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E56B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8178EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAiSummary);
export default __webpack_public_path__ + "static/media/ImgAISummary.a575d4e27ad19ad7f69f36e742ec93d4.svg";
export { ForwardRef as ReactComponent };